import { render } from "./Radio.vue?vue&type=template&id=48351f3b&scoped=true"
import script from "./Radio.vue?vue&type=script&lang=js"
export * from "./Radio.vue?vue&type=script&lang=js"

import "./Radio.vue?vue&type=style&index=0&id=48351f3b&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.26_vue@3.5.26_webpack@5.104.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48351f3b"]])

export default __exports__